import { render } from "./cameraManage.vue?vue&type=template&id=ef02f262&scoped=true"
import script from "./cameraManage.vue?vue&type=script&lang=js"
export * from "./cameraManage.vue?vue&type=script&lang=js"

import "./cameraManage.vue?vue&type=style&index=0&id=ef02f262&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ef02f262"

export default script